/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui core components
import { List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
import ContactInfo from "views/Intro/Sections/ContactInfo.js";

import styles from "assets/jss/material-kit-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <div>
    <footer className={footerClasses} style={{ backgroundColor: '#134c7a' }}>
      <GridContainer md={12} sm={12} xs={12}>
        <GridItem xs={12} sm={12} md={4}>
          <div className={classes.container}>
            <div style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}>
              <Button
                href="/"
                color="transparent"
                className={classes.navLink}
                style={{ color: 'white', width: '200px', margin: 0 }}
              >
                गृहपृष्ठ
              </Button><br/>
              <Button
                href="/project/?ref=footer"
                color="transparent"
                className={classes.navLink}
                style={{ color: 'white', width: '200px', margin: 0 }}
              >
                योजनाहरु
              </Button><br/>
              <Button
                href="/budget/?ref=footer"
                color="transparent"
                className={classes.navLink}
                style={{ color: 'white', width: '200px', margin: 0 }}
              >
                बजेट तथा कार्यक्रम
              </Button><br/>
              <Button
                href="/laws/?ref=footer"
                color="transparent"
                className={classes.navLink}
                style={{ color: 'white', width: '200px', margin: 0 }}
              >
                ऐन कानून संग्रह
              </Button><br/>
              <Button
                href="/ngo/?ref=footer"
                color="transparent"
                className={classes.navLink}
                style={{ color: 'white', width: '200px', margin: 0 }}
              >
                गैरसरकारी संस्था
              </Button><br/>
            </div>
            <div className={classes.left}>

            </div>
          </div>
        </GridItem>
        <GridItem xs={12} sm={6} md={4}>
          <div className={classes.container}>
            <div style={{ margin:0, padding:0, paddingRight:'10px', paddingLeft: '10px' }}>
              <Button
                href="/intro"
                color="transparent"
                className={classes.navLink}
                style={{ color: 'white', width: '200px', margin: 0 }}
              >
                जि.स.स. भक्तपुर
              </Button><br/>
              <Button
                href="/intro/changunarayan"
                color="transparent"
                className={classes.navLink}
                style={{ color: 'white', width: '200px', margin: 0 }}
              >
                चाँगुनारायण नगरपालिका
              </Button><br/>
              <Button
                href="/intro/bhaktapur"
                color="transparent"
                className={classes.navLink}
                style={{ color: 'white', width: '200px', margin: 0 }}
              >
                भक्तपुर नगरपालिका
              </Button><br/>
              <Button
                href="/intro/madhyapur_thimi"
                color="transparent"
                className={classes.navLink}
                style={{ color: 'white', width: '200px', margin: 0 }}
              >
                मध्यपुर थिमि नगरपालिका
              </Button><br/>
              <Button
                href="/intro/suryabinayak"
                color="transparent"
                className={classes.navLink}
                style={{ color: 'white', width: '200px', margin: 0 }}
              >
                सूर्यविनायक नगरपालिका
              </Button>
            </div>
          </div>
        </GridItem>

        <GridItem xs={12} sm={6} md={4}>
          <div style={{ margin: '10px' }}>
            {props.contact_info ? props.contact_info : <ContactInfo selection="bhaktapur_ddc" />}
          </div>
        </GridItem>
      </GridContainer>
    </footer>
    <div className={footerClasses} style={{ backgroundColor: '#222', paddingTop: 0, paddingBottom: 0}}>
      <div className={classes.container}>
        {/*<div className={classes.right} style={{ padding:0, color: '#fff' }}>
          &copy; {1900 + new Date().getYear()}, {" "}
          <a
            href=".?ref=footer"
            className={aClasses}
            style={{ color: '#ddf' }}
            target="_blank"
          >
            --
          </a>{" "}
          --
        </div>*/}
        <div style={{ padding:0, color: '#fff', margin: 0, float: 'left', fontSize: 'small'}}>
          Developed by: Center for Development and Digital Humanities (DevDH), Kathmandu
          <br />
          Email:
          <a
            href="mailto:center4devdh@gmail.com"
            className={aClasses}
            style={{ color: '#ddf' }}
            target="_blank"
          >
            center4devdh@gmail.com
          </a>{" "}| Contact: 9808170739
        </div>
        <div className={classes.right} style={{ padding:0, color: '#fff', fontFamily: 'nepali-font', marginTop: '10px' }}>
          &copy; {1900 + new Date().getYear()}, {" "}
          <a
            href=".?ref=footer"
            className={aClasses}
            style={{ color: '#ddf' }}
            target="_blank"
          >
            जिल्ला समन्वय समिति, भक्तपुर
          </a>{" "}
        </div>
      </div>
    </div>
    </div>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
